// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file LoadedSpritesheet type declaration.
 * @author James Reid
 */

// @ts-check

// @@imports-types
/* eslint-disable no-unused-vars -- Types only used in comments. */
import { Texture } from "pixi.js"
/* eslint-enable no-unused-vars -- Close disable-enable pair. */

// @@body
/**
 * Loaded spritesheet typedef as produced by Pixi when parsing a spritesheet
 * asset into a set of useable textures.
 * @typedef {Object.<string,Texture>} LoadedSpritesheet
 */

// @@exports
/**
 * @type {LoadedSpritesheet}
 * @ignore
 */
export let LoadedSpritesheet
